/**
 * Csv Schema of Banner
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {Banner} from '@/model/resource/Banner'

/* TODO: review generated schema */
export class CsvBannerSchema extends Schema {
  readonly name = 'CsvBanner'

  readonly fieldSet: FieldSet<Banner> = {
    idBannerPk: schema => schema.model.idBannerPk,
    nome: schema => schema.model.nome,
    urlImagem: schema => schema.model.urlImagem,
    urlRedirect: schema => schema.model.urlRedirect,
    dataInicio: schema => Helper.datetime(schema.model.dataInicio),
    dataFim: schema => Helper.datetime(schema.model.dataFim),
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
